import React from 'react';
import type {
  SearchUserWabikenMetasQuery,
  SearchUserWabikenMetasQueryVariables,
} from '@/API';
import { searchUserWabikenMetas } from '@/graphql/queries';
import { useAmplifyGraphql } from '@/shared/hooks/useAmplifyFetcher';

export function useSearchUserWabikenMetasQuery() {
  const { fetcher } = useAmplifyGraphql<
    SearchUserWabikenMetasQuery,
    SearchUserWabikenMetasQueryVariables
  >();

  const searchUserWabikenMetasQuery = React.useCallback(
    (variables: SearchUserWabikenMetasQueryVariables) =>
      fetcher(searchUserWabikenMetas, variables),
    [fetcher]
  );

  return {
    searchUserWabikenMetasQuery,
  };
}
